import React from 'react';
import PropTypes from 'prop-types';
import { TextFieldStyled } from './styles';

export const PhoneInputComponent = React.forwardRef(({
  hasError,
  helperText,
  labelText,
  onBlur,
  onChange,
  onKeyUp,
  themeType,
  value,
  ...rest
}, ref) => (
  <TextFieldStyled
    hasError={hasError}
    helperText={helperText}
    hideRequiredAsterisk={rest.hideRequiredAsterisk}
    id='in-page-lead-form-phone-input'
    labelText={labelText}
    maxLength={14}
    name='phone'
    onBlur={onBlur}
    onChange={onChange}
    onKeyUp={onKeyUp}
    ref={ref}
    required={true}
    themeType={themeType}
    type='tel'
    value={value}
  />
));

PhoneInputComponent.propTypes = {
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  value: PropTypes.string,
};

export default PhoneInputComponent;
